import api from '@/utils/api'

export default {
    getAssignmentStatusCount(filter) {
        return api.get('assignments/counts' + (filter.clientId ? '?clientId=' + filter.clientId : '') + (filter.contractorId ? '&contractorId=' + filter.contractorId : ''))
    }
}
